import { useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import Layout from 'shared/routes/components/layout/Layout';

interface IProps {
  children: React.ReactNode;
}

const PrivateRoute = ({ children }: IProps) => {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) {
    return <Layout>{children}</Layout>;
  }
  return <Navigate to="/" />;
};

export default PrivateRoute;
